import React, { useState } from 'react'
import { BrowserRouter } from 'react-router-dom'
import ReactDOM from 'react-dom/client'
import AdminPage from './pages/AdminPage'
import AdminLogin from './pages/AdminLogin'
import './styles/index.css'
import './App.css'

function AdminApp() {
  const [token, setToken] = useState(() => localStorage.getItem('adminToken'))

  const handleLogin = (authToken) => {
    localStorage.setItem('adminToken', authToken)
    setToken(authToken)
  }

  const handleLogout = () => {
    localStorage.removeItem('adminToken')
    setToken(null)
  }

  return token ? <BrowserRouter><div className="admin-standalone"><AdminPage onLogout={handleLogout} /></div></BrowserRouter> : <AdminLogin onLogin={handleLogin} />
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <AdminApp />
  </React.StrictMode>,
)
